export const CATS = [
  {
    id: `1`,
    name: 'Fluffy',
    image: '/assets/images/cat-head-1.jpg',
    alt: 'Light-colored cat close up.',
    color: '',
    type: 'American Shorthair',
    age: '2 years old',
    shortDescription: 'Fluffy is a very affectionate female cat.',
    longDescription:
      'Fluffy is a very affectionate female cat. She loves to play and does well with children and dogs.',
  },
  {
    id: `2`,
    name: 'Princess',
    image: '/assets/images/cat-head-2.jpg',
    alt: 'Striped white gray and white cat close up.',
    color: '',
    type: 'Calico',
    age: '4 years old',
    shortDescription: 'This is a short description.',
    longDescription:
      'This is a longer card with supporting text below as a natural lead-in to additional content.',
  },
  {
    id: `3`,
    name: 'Tiger',
    image: '/assets/images/cat-head-3.jpg',
    alt: 'Striped gray and white cat close up.',
    color: 'gray',
    type: 'Calico',
    age: '4 years old',
    shortDescription: 'This is a short description.',
    longDescription:
      'This is a longer card with supporting text below as a natural lead-in to additional content.',
  },
  {
    id: `4`,
    name: 'Carrot',
    image: '/assets/images/cat-head-4.jpg',
    alt: 'Orange cat close up.',
    color: 'orange',
    type: 'American Shorthair',
    age: '4 months old',
    shortDescription: 'This is a short description.',
    longDescription:
      'This is a longer card with supporting text below as a natural lead-in to additional content.',
  },
  {
    id: `5`,
    name: 'Jasper',
    image: '/assets/images/cat-head-1.jpg',
    alt: 'Light-colored cat close up.',
    color: '',
    type: 'American Shorthair',
    age: '2 years old',
    shortDescription: 'Fluffy is a very affectionate female cat.',
    longDescription:
      'Fluffy is a very affectionate female cat. She loves to play and does well with children and dogs.',
  },
  {
    id: `6`,
    name: 'Fifi',
    image: '/assets/images/cat-head-2.jpg',
    alt: 'Striped white gray and white cat close up.',
    color: '',
    type: 'Calico',
    age: '4 years old',
    shortDescription: 'This is a short description.',
    longDescription:
      'This is a longer card with supporting text below as a natural lead-in to additional content.',
  },
  {
    id: `7`,
    name: 'Doc',
    image: '/assets/images/cat-head-3.jpg',
    alt: 'Striped gray and white cat close up.',
    color: 'gray',
    type: 'Calico',
    age: '4 years old',
    shortDescription: 'This is a short description.',
    longDescription:
      'This is a longer card with supporting text below as a natural lead-in to additional content.',
  },
  {
    id: `8`,
    name: 'Pumpkin',
    image: '/assets/images/cat-head-4.jpg',
    alt: 'Orange cat close up.',
    color: 'orange',
    type: 'American Shorthair',
    age: '4 months old',
    shortDescription: 'This is a short description.',
    longDescription:
      'This is a longer card with supporting text below as a natural lead-in to additional content.',
  },
]
